import React from "react";
import List from "../components/List";
import hipladeTemplate from "../../common/template";

function CoursesList() {
  return <List />;
}

export default hipladeTemplate(CoursesList);
